export const Gender = {
  Female: 0,
  Male: 1,
} as const

export type Gender = 0 | 1

export const isValidGender = (gender: unknown): gender is Gender =>
  gender === Gender.Female || gender === Gender.Male
